<template>
    <div class="mb-5"> 
        <input
            v-if="filteredMails"
            type="hidden"
            name="mails"
            :value="filteredMails"
        >
        <input
            type="hidden"
            name="filters"
            :value="JSON.stringify(clauseGroups)"
        >

        <div
            v-if="!hidden"
            class="card bg-secondary p-3"
        >
            <div class="row">
                <div class="col col-md-2">
                    <div
                        v-if="clauseGroups.length > 1"
                        class="mb-5 h-100"
                    >
                        <div class="text-center float-left h-100 text-light">
                            <span style="position: absolute; top:50%; margin-top: -15px; text-align: right; padding-right: 60px; right: 0;">
                                <strong>ИЛИ</strong>
                            </span>
                        </div>
                        <div style="border-top: 2px solid white; border-left: 2px solid white; height: 100%; border-bottom: 2px solid white; width: 30px; float: right; border-top-left-radius: 10px; border-bottom-left-radius: 10px;" />
                    </div>
                </div>
                <div class="col col-md-10">
                    <div
                        v-for="(group, groupIndex) in clauseGroups"
                        :key="groupIndex"
                        class="card mb-3 mt-3 appear"
                    >
                        <div class="card-body row">
                            <div class="col col-md-2">
                                <div
                                    v-if="group.items.length > 1" 
                                    class="mb-5 h-100"
                                >
                                    <div class="text-center mb-5 float-left h-100 text-dark">
                                        <span style="position: absolute; top:50%; margin-top: -12px; text-align: right; padding-right: 45px; right: 0;">
                                            <strong>И</strong>
                                        </span>
                                    </div>
                                    <div style="border-top: 2px solid #404040; border-left: 2px solid #404040; height: 100%; border-bottom: 2px solid #404040; width: 20px; float: right; border-top-left-radius: 10px; border-bottom-left-radius: 10px;" />
                                </div>
                            </div>
                            <div class="col col-md-10">
                                <div
                                    v-for="(item, itemIndex) in group.items"
                                    :key="itemIndex"
                                >
                                    <div class="card bg-light mb-2 mt-2 appear">
                                        <div class="card-header">
                                            <div class="row">
                                                <div class="col col-md-6">
                                                    <div class="input-group">
                                                        <div
                                                            class="input-group-append"
                                                            style="width: 100%;"
                                                        >
                                                            <select
                                                                v-model="item.type"
                                                                class="form-control"
                                                            >
                                                                <option
                                                                    v-if="!item.type"
                                                                    value=""
                                                                >
                                                                    Выберите условие
                                                                </option>
                                                                <option
                                                                    v-for="type in types"
                                                                    :key="type.type"
                                                                    :value="type.type"
                                                                >
                                                                    {{ type.name }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col col-md-5">
                                                    <div
                                                        v-if="item.type"
                                                        class="text-left mt-1"
                                                    >
                                                        <span
                                                            v-if="quantityLocks[item.id]"
                                                            class="fa fa-spinner fa-lg fa-pulse"
                                                        />
                                                        <span
                                                            v-else
                                                            title="Найдено адресов"
                                                        >
                                                            <span class="fa fa-user fa-lg" />
                                                            <strong> ~ {{ item.count }}</strong>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col col-md-1">
                                                    <div 
                                                        class="btn btn-danger float-right"
                                                        @click="removeItem(groupIndex, itemIndex)" 
                                                    >
                                                        <span class="fa fa-close" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="card-body"
                                            style="background-color: #ffffff;"
                                        >
                                            <custom-property-filter
                                                v-if="customProperties.includes(item.type)"
                                                :id="item.id"
                                                :siteid="siteid"
                                                :content="item"
                                                :propertykey="item.type"
                                                @change="updateItem"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-md-2" />
                            <div class="col col-md-10 text-right">
                            <hr>
                                <span
                                    class="btn btn-info mt-2"
                                    @click="addItem(group.index)"
                                >
                                    <span class="fa fa-plus" /> Добавить условие
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col col-md-2" />
                <div class="col col-md-10">
                    <hr>
                    <div class="row text-left">
                        <span
                            class="btn btn-light ml-3"
                            @click="addGroup"
                        >
                            <span class="fa fa-plus" /> Добавить группу условий "ИЛИ"
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group mb-2 mt-3 row">
            <div class="col col-md-3 col-form-label">
                Получателей: 
            </div>
            <div class="col col-md-9">
                <span class="btn btn-light">
                    <strong>{{ filteredCount }}</strong>
                </span>
                <div class="float-right">
                    <span 
                        class="ml-3 btn"
                        style="min-width: 140px;"
                        :class="{'btn-secondary': !hidden, 'filterbtn-active': !hidden, 'btn-outline-secondary': hidden}"
                        @click="toggleVisibility"
                    >
                        <span class="fa fa-filter" />
                        &nbsp; Фильтр
                        <span v-if="filtersCount > 0">
                            ({{ filtersCount }})
                        </span>
                    </span>
                    <span 
                        class="btn btn-primary ml-3" 
                        :class="{'disabled': locked}"
                        @click="getMails"
                    >
                        <span
                            class="fa" 
                            :class="{'fa-refresh': !locked, 'fa-spinner': locked, 'fa-pulse': locked}" 
                        />
                        Применить фильтр 
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CategoryField from './CategoryField.vue';
    import ProductField from './ProductField.vue';
    import SumField from './SumField.vue';
    import OrderField from './OrderField.vue';
    import PropertyField from './PropertyField.vue';

    export default {
        name: 'GAFilter',
        components: {
            'custom-property-filter': PropertyField, 
        },
        props: {
            siteid: {
                type: Number,
                default: 0,
            },
            mails: {
                type: Number,
                default: 0,
            },
            allmails: {
                type: Number,
                default: 0,
            },
            filters: {
                type: String,
                default: null 
            },
            maillist: {
                default: null 
            },
            properties: {
                type: Array,
                default: function() { return [] }
            }
        },
        data: function() {
            return { 
                clauseGroups: [],
                countCache: {},
                delayTimers: {},
                quantityLocks: {},
                idCounter: 0,
                productsCache: null,
                categoriesCache: null,
                filteredMails: null,
                filteredCount: null,
                hasValidClauses: false,
                hidden: true,
                locked: false,
                customProperties: [],
                types: [
                ]
            }
        },
        computed: {
            filtersCount: function () {
                let total = 0; 
                this.clauseGroups.forEach(function (group) {
                    group.items.forEach(function (item) {
                        if (item['type']) {
                            total = total+1;
                        }
                    });
                })
                return total; 
            }
        },
        mounted: function() {
            let ap = this;
            let maxId = 0;
            let filters = null;

            if (this.properties) {
                ap.properties.forEach(function (item) {
                    ap.types.push({'type': item.name, 'name': item.label});
                    ap.customProperties.push(item.name);
                })
            }

            if (this.filters) {
                filters = JSON.parse(this.filters);
            }

            if (this.maillist) {
                this.filteredMails = JSON.stringify(this.maillist);
                this.filteredCount = this.maillist.length;
            } else {
                this.filteredCount = this.allmails;
            }

            if (filters) {
                filters.forEach(function (group) {
                    group['items'].forEach(function (value) {
                        if (value.id > maxId) {
                            maxId = value.id
                        }
                    })
                })
                this.idCounter = maxId+1;
                this.clauseGroups = filters;
            }
        },
        methods: {
            addGroup: function() {
                const idx = this.clauseGroups.length; 
                this.clauseGroups.push({
                    'index': idx,
                    'clause': 'and',
                    'items': []
                });
                this.addItem(idx);
            },
            addItem: function(index) {
                this.idCounter++;
                this.delayTimers[this.idCounter] = null;
                this.clauseGroups[index]['items'].push({
                    'id': this.idCounter,
                    'type': '',
                    'text': '',
                    'clause': '',
                    'start': null, 
                    'end': null, 
                });
            },
            getTypeProperty: function(type, property) {
                this.types.forEach(function(item, index) {
                    if (item.type === type){
                        return item[property];
                    }
                });
            },
            removeItem: function(groupIndex, itemIndex) {
                if (this.clauseGroups[groupIndex]['items'].length == 1) {
                    this.clauseGroups.splice(groupIndex, 1);

                    for (const [idx, value] of this.clauseGroups.entries()) {
                        this.clauseGroups[idx]['index'] = idx;
                    }
                } else {
                    this.clauseGroups[groupIndex]['items'].splice(itemIndex, 1);
                }
                if (this.clauseGroups.length == 0) {
                    this.getMails();
                    this.hidden = true;
                }
            },
            show: function() {
                this.hidden = false;
            },
            hide: function() {
                this.hidden = true;
            },
            toggleVisibility: function() {
                if (this.clauseGroups.length == 0) {
                    this.addGroup();
                }
                this.hidden = !this.hidden;
            },
            updateDate: function(e) {
                console.log(e.date);
            },
            emitChange: function(val) {
                this.$emit('change', this.value, );
            },
            updateItem: function(val) {
                let ap = this;
                let hash = ap.hashObject(val)
                ap.quantityLocks[val.id] = true;
                ap.setItemValues(val);

                if (this.countCache[hash] !== undefined) {
                    val.count = this.countCache[hash];
                    ap.setItemValues(val);
                    ap.quantityLocks[val.id] = false;
                } else {
                    clearTimeout(ap.delayTimers[val.id]);
                    ap.delayTimers[val.id] = setTimeout(function() {
                        $.ajax({
                            type: "POST",
                            url: '/analytics/'+ap.siteid+'/users/',
                            data: {
                                filter: JSON.stringify(
                                    [{
                                        count: true,
                                        group: 'and',
                                        items: [val]
                                    }]
                                )
                            }, 
                            success: function ( data ) {
                                val.count = data.count;
                                ap.countCache[hash] = data.count;
                                ap.setItemValues(val);
                                ap.quantityLocks[val.id] = false;
                            },
                            error: function(error) {
                                alert('Ошибка при получении пользователей');
                                ap.quantityLocks[val.id] = false;
                                return;
                            }
                        });
                    }, 2000);
                }
            },
            getMails: function() {
                let ap = this;
                ap.locked = true;

                ap.$emit('busy', true);

                $.ajax({
                    type: "POST",
                    url: '/analytics/'+ap.siteid+'/users/',
                    data: {
                        filter: JSON.stringify(ap.clauseGroups)
                    }, 
                    success: function ( data ) {
                        ap.hasValidClauses = data.clauses.length > 0 ? true : false;

                        if (data.clauses) {
                            ap.filteredMails = JSON.stringify(data.items);
                            ap.filteredCount = data.count;
                        } else {
                            ap.filteredMails = '';
                            ap.filteredCount = ap.allmails;
                        }

                        ap.locked = false;
                        ap.$emit('busy', false);
                        //val.count = data.count;
                        //ap.countCache[hash] = data.count;
                        //ap.setItemValues(val);
                        //ap.quantityLocks[val.id] = false;
                    },
                    error: function(error) {
                        ap.locked = false;
                        ap.$emit('busy', false);
                        alert('Ошибка при получении пользователей');
                        //ap.quantityLocks[val.id] = false;
                        return;
                    }
                });
            },
            setItemValues: function(val) {
                for (const [g, group] of this.clauseGroups.entries()) {
                    for (const [i, item] of group.items.entries()) {
                        if (item.id == val.id) {
                            this.clauseGroups[g]['items'][i] = Object.assign(this.clauseGroups[g]['items'][i], val);
                            Vue.set(this.clauseGroups, g, this.clauseGroups[g]);
                            return
                        }
                    }
                }
            },
            hashObject: function(obj) {
                let hashable = {
                    'type': obj.type,
                    'start': moment(obj.start).calendar(),
                    'end': moment(obj.end).calendar(),
                    'clause': obj.clause,
                    'sum': obj.sum,
                    'text': obj.text,
                    'products': obj.products,
                    'categories': obj.categories,
                }
                return objectHash.sha1(hashable);
            },
            storeCache: function(products) {
                this.productsCache = products;
            },
            storeCategoriesCache: function(categories) {
                this.categoriesCache = categories;
            }
        },
    }
</script>
